import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { EventsService } from '@schoolbelle/common/events';
import { isIE, isEdge, isSafari } from '@schoolbelle/common/functions';
import { fromEvent, merge, Subscription } from 'rxjs';
import { tap, throttleTime } from 'rxjs/operators';


@Directive({
    selector: '[password-view-toggle]',
})
export class PasswordViewToggleDirective implements OnInit, OnDestroy {
  private iconElem: HTMLElement;
  private parentElem: HTMLElement;
  private inputElem: HTMLInputElement;
  private subscriptions = new Subscription();

  private _shown = false;
  constructor(
      private el: ElementRef,
      private events: EventsService
  ) {
    this.parentElem = this.el.nativeElement.parentNode;
    this.inputElem = this.el.nativeElement;
    this.iconElem = document.createElement('i');
  }

  ngOnInit () {
    /**
     * IE and Edge has a built in reveal icon
     * Safari has a default auto-fill icon
     */
    if (isIE() || isEdge() || isSafari()) return;
    const type = this.el.nativeElement.getAttribute('type');
    if (type !== 'password') this.el.nativeElement.setAttribute('type', 'password');

    setTimeout(() => {
      this.setup();
    }, 1)
  }

  ngOnDestroy () {
    // method 1's listener clearing
    this.subscriptions.unsubscribe();

    // method 2's listener clearing
    // this.icon.removeEventListener('click', this.toggle);

    // method 3's listener clearing is automatic
    // nothing comes here.
  }

  toggle(_:MouseEvent) {
      this._shown = !this._shown;
      this.updateIconAttributes();
  }

  private updateIconAttributes () {
    if (this._shown) {
      this.inputElem.setAttribute('type', 'text');
      this.iconElem.setAttribute('class', 'fa fa-eye');
    } else {
      this.inputElem.setAttribute('type', 'password');
      this.iconElem.setAttribute('class', 'fa fa-eye-slash');
    }
  }

  setup() {
    const inputComp = window.getComputedStyle(this.inputElem);
    const parentComp = window.getComputedStyle(this.parentElem);
    const iconZIndex = (parseInt(inputComp.zIndex) || 0) + 1;

    const click$ = fromEvent(this.iconElem, 'click').pipe(tap(this.toggle.bind(this)));
    const resize$ = this.events.windowResize$.pipe(
      throttleTime(10, undefined, {leading: true, trailing: true}),
      tap(() => this.setIconPosition())
    );

    if (parentComp.position !== 'absolute') {
      this.parentElem.style.position = 'relative';
    }

    this.iconElem.classList.add('fa', 'fa-times');
    this.iconElem.style.position = 'absolute';
    this.iconElem.style.cursor = 'pointer';
    this.iconElem.style.zIndex = (iconZIndex > 3 ? iconZIndex : 4) + '';
    this.parentElem.appendChild(this.iconElem);
    this.updateIconAttributes();
    this.setIconPosition();


    // Method 1
    this.subscriptions.add(merge(resize$, click$).subscribe());

    // Method 2
    // this.iconElem.addEventListener('click', this.toggle));
  }

  setIconPosition() {
    const parentRect = this.parentElem.getBoundingClientRect();
    const inputRect = this.inputElem.getBoundingClientRect();
    const inputComp = window.getComputedStyle(this.inputElem);

    const iconPosY = inputRect.top - parentRect.top + (parseInt(inputComp.height) / 2);
    const iconPosX = inputRect.left - parentRect.left + parseInt(inputComp.width) - parseInt(inputComp.paddingRight);

    this.iconElem.style.top = `${iconPosY}px`;
    this.iconElem.style.left = `${iconPosX}px`;
    this.iconElem.style.transform = `translate(-100%, -50%)`;
  }

  // // Method 3
  // @HostListener('click', ['$event']) onClick (event:MouseEvent) {
  //   if (event.target !== this.iconElem) return;
  //   this.toggle();
  // }
}
